// @core/api/endpoints/product/validate_product_dependencies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ValidateProductDependenciesRequest,
  ValidateProductDependenciesResponse,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Validate product dependencies
 * Checks if a tenant meets all requirements to subscribe to a product. Returns detailed information about missing dependencies and recommendations.
 */
export async function ValidateProductDependencies(
  product_id: string,
  data: ValidateProductDependenciesRequest,
  options?: RequestOptions
): Promise<ValidateProductDependenciesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/dependencies/validate`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.post<ValidateProductDependenciesResponse>(requestPath, data, requestOptions);
}
